import { render, staticRenderFns } from "./ClassroomTypeView.vue?vue&type=template&id=5e7a6865&scoped=true"
import script from "./ClassroomTypeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomTypeView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClassroomTypeView.vue?vue&type=style&index=0&id=5e7a6865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a6865",
  null
  
)

export default component.exports